import PropTypes from "prop-types"
import React from "react"

import Badge from "src/components/Badge"
import { statusToken } from "src/components/Badge/status_tokens"

import { formatListTimestamp } from "src/utils/date_helpers"
import { humanize } from "src/utils/string_helpers"

const ChatThreadRow = ({
  title,
  subtitle,
  dates,
  status,
  messagePreview,
  timestamp,
  unread = false,
  detailPath,
}) => {
  const fontStyleClass = unread ? "font-bold text-gray-900" : "text-gray-600"

  return (
    <a href={detailPath} className="no-underline">
      <div className="flex w-full cursor-pointer flex-row items-center justify-between rounded px-1 py-3 hover:bg-gray-100">
        {/* Unread indicator */}
        <div className="w-4 flex-none">
          {unread && (
            <div
              data-testid="unread-indicator"
              className="h-2 w-2 rounded-full bg-blue-600"
            />
          )}
        </div>

        {/* Main content */}
        <div className="min-w-0 flex-1 px-2">
          <div className="flex items-center justify-between">
            <span className="font-semibold text-gray-900">{title}</span>
            <span className={`text-xs ${fontStyleClass}`}>
              {formatListTimestamp(timestamp)}
            </span>
          </div>
          <div className="flex items-center gap-2">
            {subtitle && (
              <>
                <span className="text-sm text-gray-600">{subtitle}</span>
              </>
            )}
            {dates && (
              <>
                {subtitle && <span className="text-gray-400">|</span>}
                <span className="text-sm text-gray-500">{dates}</span>
              </>
            )}
          </div>
          <div className="flex items-center justify-between">
            <div className={`mt-1 w-10/12 truncate ${fontStyleClass}`}>
              {messagePreview}
            </div>
            {/* Status badge */}
            <div className="flex-none px-2">
              {status && (
                <Badge
                  color={statusToken(humanize(status))}
                  text={humanize(status)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </a>
  )
}

ChatThreadRow.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  dates: PropTypes.string,
  status: PropTypes.string,
  messagePreview: PropTypes.string,
  timestamp: PropTypes.string,
  unread: PropTypes.bool,
  detailPath: PropTypes.string.isRequired,
}

export default ChatThreadRow
